import { Subject } from '~/rage/utils';
import { rage } from '~/rage';
import { Layouts } from '~/shared';
import {
	HouseScreenshotView,
	IHousesEditorService,
} from './HousesEditorService';

export class HousesEditorServiceStub implements IHousesEditorService {
	private previewing = new Subject(false);
	private photoActive = new Subject(false);
	private busy = new Subject(false);
	private screenshotView = new Subject<HouseScreenshotView>(null);
	public getBusy() {
		return this.busy;
	}
	public getScreenshot() {
		return this.screenshotView;
	}
	public clearScreenshot() {
		this.screenshotView.next(null);
	}
	public async copyScreenshot() {
		throw new Error('Снимки доступны только в игре.');
	}
	public async copyLocationRow(row: string) {
		if (navigator.clipboard?.writeText)
			await navigator.clipboard.writeText(row);
		else rage.input.copyToClipboard(row);
	}
	public getPhotoActive() {
		return this.photoActive;
	}
	public getPreviewing() {
		return this.previewing;
	}
	public async getPosition() {
		return { x: 35.3303, y: 6662.9414, z: 32.1904 };
	}
	public async preview(_interiorId: string) {
		await this.stopPhoto();
		this.previewing.next(true);
	}
	public async returnToStart() {
		await this.stopPhoto();
		this.previewing.next(false);
	}
	public async hide() {
		rage.gui.setLayoutVisibleState(Layouts.HousesEditor, false);
	}
	public async preparePhoto() {
		this.photoActive.next(true);
		await this.hide();
	}
	public async stopPhoto() {
		this.photoActive.next(false);
	}
	public async close() {
		await this.hide();
	}
	public async screenshot(): Promise<void> {
		throw new Error('Снимки доступны только в игре.');
	}
}
